import { render, staticRenderFns } from "./ButtonWithIcon.vue?vue&type=template&id=fbe40d12&scoped=true&"
import script from "./ButtonWithIcon.vue?vue&type=script&lang=js&"
export * from "./ButtonWithIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbe40d12",
  null
  
)

export default component.exports